import { render } from "./DayList.vue?vue&type=template&id=9b225672"
import script from "./DayList.vue?vue&type=script&lang=js"
export * from "./DayList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__